import { render } from "./transaction-detail.vue?vue&type=template&id=9f536ab6&scoped=true"
import script from "./transaction-detail.vue?vue&type=script&lang=js"
export * from "./transaction-detail.vue?vue&type=script&lang=js"

import "./transaction-detail.vue?vue&type=style&index=0&id=9f536ab6&scoped=true&lang=css"

import exportComponent from "D:\\01_Dev\\Projects\\active\\YouYouXiChe\\smart-car-wash-background\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f536ab6"]])

export default __exports__